import qs from 'qs';

/**
 * 获取地址 search 参数
 * @param queryString - url 搜索部分, 如: https://www.npmjs.com/package/qs?value=123, queryString 的值应为: value=123, 默认使用地址栏的 search
 * @param opts - parse 参数
 *
 * 例如: qs.getSearchParams('value=123&name=allen')
 * 返回: "{\"value\":\"123\",\"name\":\"allen\"}" 对象
 *
 * 例如地址栏是: https://www.npmjs.com/package/qs?utm_source=wx
 * const searchParams = qs.getSearchParams();
 * console.log(searchParams.utm_source);
 * // wx
 *
 * @returns {object}
 */
qs.getSearchParams = (queryString = window.location.search.slice(1), opts) => {
  return qs.parse(queryString, opts);
};

/** 获取地址栏参数 */
export const getParamsByQs = (url = window.location.href) => {
  return qs.parse(url.split('?')[1]) || {};
};

const splitHashUrl = url => {
  const hashIndex = url.indexOf('#');
  const baseUrl = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex + 1);
  const queryIndex = hash.indexOf('?');

  return {
    baseUrl,
    hashPath: queryIndex === -1 ? hash : hash.slice(0, queryIndex),
    hashSearch: queryIndex === -1 ? '' : hash.slice(queryIndex + 1)
  };
};

/** 获取 hash 路由中的 query 参数 */
export const getHashParams = (url = window.location.href) => {
  return qs.parse(splitHashUrl(url).hashSearch) || {};
};

/**
 * 更新 hash 路由中的 query 参数，不修改 hash 前的 search
 * @param {Object} params - 要更新的参数对象，值为 null 或 undefined 表示删除该参数
 * @param {string} url - 要更新的 URL，默认为当前地址栏 URL
 * @param {boolean} replace - 是否使用 replaceState（true）还是 pushState（false），默认为 true
 * @param {boolean} triggerHashChange - 是否手动触发 hashchange 事件，默认为 true
 * @returns {string} 返回更新后的完整 URL
 */
export const updateHashParams = (params = {}, url = window.location.href, replace = true, triggerHashChange = true) => {
  const { baseUrl, hashPath, hashSearch } = splitHashUrl(url);
  const hashParams = qs.parse(hashSearch) || {};

  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value === null || value === undefined) {
      delete hashParams[key];
      return;
    }
    hashParams[key] = value;
  });

  const queryString = qs.stringify(hashParams);
  const newURL = `${baseUrl}#${hashPath}${queryString ? `?${queryString}` : ''}`;

  if (url === window.location.href) {
    const oldURL = window.location.href;
    replace ? window.history.replaceState({}, '', newURL) : window.history.pushState({}, '', newURL);
    if (triggerHashChange) {
      const hashChangeEvent = new HashChangeEvent('hashchange', { oldURL, newURL });
      window.dispatchEvent(hashChangeEvent);
    }
  }

  return newURL;
};

/**
 * 更新地址栏参数
 * @param {Object} params - 要更新的参数对象，值为 null 或 undefined 表示删除该参数
 * @param {string} url - 要更新的 URL，默认为当前地址栏 URL
 * @param {boolean} replace - 是否使用 replaceState（true）还是 pushState（false），默认为 true
 * @param {boolean} triggerHashChange - 是否手动触发 hashchange 事件，默认为 true
 * @returns {string} 返回更新后的完整 URL
 */
export const updateUrlParams = (params = {}, url = window.location.href, replace = true, triggerHashChange = true) => {
  const [baseUrl, search] = url.split('?');
  const searchParams = qs.parse(search) || {};

  // 更新参数，处理删除操作
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value === null || value === undefined) {
      delete searchParams[key];
      return;
    }
    // 更新参数
    searchParams[key] = value;
  });

  // 构建新的 URL
  const queryString = qs.stringify(searchParams);
  const newURL = queryString ? `${baseUrl}?${queryString}` : baseUrl;

  // 更新浏览器地址栏
  if (url === window.location.href) {
    replace ? window.history.replaceState({}, '', newURL) : window.history.pushState({}, '', newURL);
    // 手动触发 hashchange 事件
    if (triggerHashChange) {
      const hashChangeEvent = new HashChangeEvent('hashchange', { oldURL: window.location.href, newURL });
      window.dispatchEvent(hashChangeEvent);
    }
  }

  return newURL;
};

export default qs;
